
import {
  SOFTSEGUROS_VENDEDORES_GET_REQUEST,
  SOFTSEGUROS_VENDEDORES_GET_SUCCESS,
  SOFTSEGUROS_VENDEDORES_GET_ERROR,
} from 'Redux/types/softsegurosVendedoresTypes';

const initialState = {
  vendedores: [], // Listado con los registros
  requestState: {
    isFeching: false,
    message: '',
    statusCode: null,
  },
};

const softsegurosVendedores = (state = initialState, action) => {
  switch (action.type) {
    case SOFTSEGUROS_VENDEDORES_GET_REQUEST:
      return ({
        ...state,
        requestState: {
          ...initialState.requestState,
          isFeching: true,
        },
      });
    case SOFTSEGUROS_VENDEDORES_GET_SUCCESS:
      return {
        ...state,
        vendedores: action.response.data,
        requestState: {
          ...initialState.requestState,
          isFeching: true,
        },
      };
    case SOFTSEGUROS_VENDEDORES_GET_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: action.response.data.message,
          statusCode: action.response.status,
        },
      });
    default:
      return state;
  }
};

export default softsegurosVendedores;
